<template>
    <div class="container d-flex justify-content-center">
        <div style="max-width: 564px">
            <div>
                <label for="sku" class="fw-700 mb-1 fs-4">
                    {{$trans('storefront::flexible_packaging.how_many_different_sku_will_be_using_package')}}*
                </label>
                <input type="text" class="form-control-secondary" :class="{'is-invalid': store.hasError('sku')}" name="sku" v-model="store.data.sku">
                <div v-if="store.hasError('sku')" class="text-danger" style="margin-top: 2px">
                    {{store.getError('sku')}}
                </div>
            </div>

            <div class="spacer-32"></div>
            <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-2">
                <button type="button" class="btn btn-outline-secondary text-uppercase" style="min-width: 150px" @click="store.previousStep">{{$trans('storefront::flexible_packaging.previous')}}</button>
                <button type="button" class="btn btn-secondary text-uppercase" style="min-width: 150px" @click="store.nextStep">{{$trans('storefront::flexible_packaging.next')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";

export default {
    components: {FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
}
</script>
